/** Piste vocabulary on the shared 0-10 score scale, for scorers and public UI. */
export function pisteLabel(score: number): string {
  if (score >= 9.0) return "Hero Snow";
  if (score >= 7.5) return "Firing";
  if (score >= 6.5) return "Great";
  if (score >= 5.0) return "Good";
  if (score >= 2.0) return "Challenging";
  return "Miserable";
}
